import StartPage from '../../components/pages/StartPageFlipped';
import themes from '../../themes';

export default function Startseite() {
  return <StartPage theme={themes.ziehen} station={'ziehen'} rotations={{ root: 270 }}/>;
}
